/* donation-badge.js — Dawn 15.4 safe poller */
(function () {
  function setup(badge){
    if (!badge || badge.__donationSetup) return;
    badge.__donationSetup = true;

    const out = badge.querySelector('[data-meals-count]');
    if (!out) return;
    const mealsPer = parseInt(badge.getAttribute('data-meals-per') || '5', 10);
    const TEE = /(t[-\s]?shirt|shirt|tee)/i;

    function qualifies(item){
      const type  = item.product_type || '';
      const title = item.product_title || item.title || '';
      return TEE.test(type) || TEE.test(title);
      // If you prefer tags, replace with:
      // return /donates-meals|5-meals/i.test((item.product_tags||'').toString());
    }

    async function fetchCart(){
      try {
        const res = await fetch('/cart.js?t=' + Date.now(), {
          headers: { 'Accept': 'application/json', 'Cache-Control': 'no-store' },
          cache: 'no-store', credentials: 'same-origin'
        });
        if (!res.ok) return null;
        return await res.json();
      } catch(e){ return null; }
    }

    async function update(){
      const cart = await fetchCart();
      if (!cart) return;
      let tees = 0;
      for (const item of cart.items || []) if (qualifies(item)) tees += item.quantity;
      out.textContent = tees * mealsPer;
    }

    // Initial paint, then steady polling every 1s.
    update();
    const interval = setInterval(update, 1000);

    // Clean up if the badge disappears (e.g., navigate away in theme editor)
    const obs = new MutationObserver(() => {
      if (!document.body.contains(badge)) {
        clearInterval(interval);
        obs.disconnect();
      }
    });
    obs.observe(document.body, { childList:true, subtree:true });
  }

  function boot(){
    document.querySelectorAll('.donation-badge').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // When sections reload in the editor
  document.addEventListener('shopify:section:load', boot);
})();
